import { useEffect } from "react";
import { Element } from "react-scroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./sections/Home";
import About from "./sections/About";
import Projects from "./sections/Projects";
import Skills from "./sections/Skills";
import Contact from "./sections/Contact";
import Certificates from "./sections/Certificates";

function App() {
  // SEO optimization - Add a descriptive page title
  useEffect(() => {
    document.title = "Abdullah Alioğlu | React and Frontend Developer";
  }, []);

  return (
    <div className="bg-light min-h-screen">
      <header>
        <Navbar />
      </header>

      <main id="main-content">
        <Element name="home">
          <section aria-labelledby="home-title">
            <Home />
          </section>
        </Element>

        <Element name="about">
          <section aria-labelledby="about-title">
            <About />
          </section>
        </Element>

        <Element name="projects">
          <section aria-labelledby="projects-title">
            <Projects />
          </section>
        </Element>

        <Element name="skills">
          <section aria-labelledby="skills-title">
            <Skills />
          </section>
        </Element>

        <Element name="certificates">
          <section aria-labelledby="certificates-title">
            <Certificates />
          </section>
        </Element>

        <Element name="contact">
          <section aria-labelledby="contact-title">
            <Contact />
          </section>
        </Element>
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
